var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    viewBox: "0 0 29 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98832 20.2377C9.75617 17.3238 14.2616 15.3877 16.524 14.4483C22.9631 11.7837 24.3167 11.3236 25.1869 11.3044C25.3802 11.3044 25.8056 11.3428 26.0957 11.5728C26.3277 11.7645 26.3857 12.0137 26.4244 12.2054C26.4631 12.3971 26.5018 12.7997 26.4631 13.1064C26.115 16.7487 24.6068 25.5861 23.8333 29.6502C23.5046 31.3755 22.8665 31.9506 22.2477 32.0081C20.8941 32.1231 19.8693 31.1262 18.5737 30.2828C16.524 28.96 15.3832 28.1357 13.3915 26.8322C11.0904 25.3369 12.5793 24.5126 13.8942 23.1707C14.2423 22.8256 20.1787 17.458 20.2947 16.9788C20.314 16.9213 20.314 16.6912 20.1787 16.5762C20.0433 16.4612 19.8499 16.4995 19.6952 16.5379C19.4825 16.5762 16.234 18.7232 9.91086 22.9598C8.9827 23.5924 8.15122 23.8991 7.39709 23.88C6.56561 23.8608 4.98 23.4199 3.78113 23.0365C2.33087 22.5764 1.17067 22.3272 1.26735 21.5221C1.32536 21.1003 1.90546 20.6786 2.98832 20.2377Z",
    fill: "#2F2F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2b493664f4e4db89a0828138945a49e2.svg";
export { ForwardRef as ReactComponent };